import { gql } from "@apollo/client";

export const InstalledBaseNodeAttribute = gql`
    query InstalledBaseNodeAttribute ($id: ID!) {
        installedBaseNodePropertyDefinition (id: $id) {
            id
            alias
            preferredName
            shortName
            dataType
            inputType
        }
    }
`;
